<template>
	<div>
		<VueLoading
			:active.sync="isLoading"
			:is-full-page="isLoadingIndicatorFullPage"
		></VueLoading>
		<div
			v-if="focusingField === 'category'"
			class="tableSection sectionRecommended"
		>
			<div
				class="block expense"
				:class="{
					[`category${getCategoryIcon('categoryNone')}`]: true,
					userSelectedCategory: userChoiceOfCategoryName === 'All'
				}"
				@click="userChoseACategory({ Name: 'All' }, $event)"
			>
				<div class="icon">
					<div class="glyph"></div>
				</div>

				<div class="details">
					<div class="title vendor">All Categories</div>
				</div>
			</div>
			<div
				v-for="(category, typeKey) in attributes.category"
				class="block expense"
				:class="{
					[`category${getCategoryIcon(category.Name)}`]: true,
					userSelectedCategory: category.Name === userChoiceOfCategoryName
				}"
				:key="typeKey"
				@click="userChoseACategory(category, $event)"
			>
				<div class="icon">
					<div class="glyph"></div>
				</div>

				<div class="details">
					<div class="title vendor">{{ category.Name }}</div>
					<div class="subtitle category">
						{{ category.NumOfReceipts }} expenses
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import VueLoading from "vue-loading-overlay";

export default {
	props: ["focusingField", "userChoiceOfCategoryName", "userChoseACategory"],
	data() {
		return {
			isLoading: true,
			isLoadingIndicatorFullPage: false
		};
	},
	components: {
		VueLoading
	},
	mounted() {
		if (!this.$store.state.attributes.project) {
			this.isLoading = true;
			this.$store.dispatch("loadAttribute").finally(() => {
				this.isLoading = false;
			});
		} else {
			this.isLoading = false;
		}
	},
	computed: {
		...mapState(["attributes", "isExportSuccessful"]),
		projects: {
			get: function() {
				if (this.$store) {
					return _.sortBy(this.$store.state.attributes.project, [
						function(data) {
							return data.Sort;
						}
					]);
				}
				return [];
			},
			set: function(newValue) {
				this.updateProjectOrder(newValue);
			}
		}
	}
};
</script>
